import { ProviderDetailPage } from '../ProviderDetailPage';
import type { ProviderMeta } from '../ProviderDetailPage';

const META: ProviderMeta = {
  slug: 'bolt',
  name: 'Bolt Food',
  tagline: 'Bolt third-party delivery network integration for Kenya and East Africa',
  colorClass: 'bg-[var(--chart-1)]',
  initial: 'B',
  webhookPath: '/webhooks/delivery/bolt',
  feeNote:
    'Bolt Food typically charges a base fee of KES 50–100 per delivery plus a per-km rate ' +
    'of approximately KES 20–30/km, subject to surge pricing. Exact rates are negotiated via ' +
    'the Bolt Business API contract. Chekit retains its standard delivery service fee ' +
    '(10% or configured %) on top of any third-party payout.',
};

export const BoltConfigPage = () => <ProviderDetailPage meta={META} />;
